module.exports = __webpack_public_path__ + "static/media/ml-icon.ffc1e538.png";